var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownArrowPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "433 281 6 4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m436 285-3-4h6z",
    fill: "#533FFB",
    fillRule: "evenodd",
    "data-name": "Polygon 10"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownArrowPurple);
export default __webpack_public_path__ + "static/media/dropdown_arrow_purple.ab93260010c01fd5806c08a9a947b189.svg";
export { ForwardRef as ReactComponent };